import { useEffect, useState } from "react";

import { API_BASE_URL } from "@/api/api.config";
import useRestQuery from "@/remoteState/useRestQuery";

const useClassroomRosterChoiceGet = (options) => {
  const queryResponse = useRestQuery(
    `${API_BASE_URL}/api/v2/roster-choice/`,
    options,
  );
  const [response, setResponse] = useState(queryResponse);

  useEffect(() => {
    setResponse(queryResponse);
  }, [queryResponse]);

  return [response, (data) => setResponse({ data })];
};

export default useClassroomRosterChoiceGet;
